<template>
  <div
    @click="onUserClicked"
    class="user-avatar-root"
    :class="{ active: isActive, 'unpaid-subscription': user.HasPaidSubscription === false }"
  >
    <div class="user-avatar-content">
      <div
        class="image-root"
        :style="{ backgroundImage: 'url(' + user.ProfileUrl + ')' }"
      >
        <div v-if="isUserManagment" @click="onPolaznikDelete" class="delete-user-icon">
          <img src="../../assets/icons/close.png" />
        </div>  
        <p v-if="!user.ProfileUrl">
          {{ user.Name.split(" ")[0][0] }}{{ user.Name.split(" ")[1][0] }}
        </p>
      </div>
      <p class="user-name">
        {{ user.Name.split(" ")[0] }} {{ user.Name.split(" ")[1] }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: ["user", "isActive", "isUserManagment"],
  methods: {
    onUserClicked() {
      this.$emit("userClicked", this.user.UserId);
    },
    onPolaznikDelete(e){
      e.stopPropagation();
      this.$emit('deletePolaznik', this.user.UserId)
    }
  },
};
</script>
<style scoped>
.user-avatar-root {
  display: inline-block;
  width: 28%;
  text-align: center;
  margin: 20px 10px;
  cursor: pointer;
}
.user-avatar-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px;
}
.unpaid-subscription .user-avatar-content {
  background-color: rgba(255, 45, 45, .2);
}

.image-root {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #f6f6f6;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.user-avatar-root:hover .delete-user-icon {
  display: block;
}
.delete-user-icon {
  width: 25px;
  height: 25px;
  position: absolute;
  top: -5px;
  right: -25px;
  display: none;
  border-radius: 50%;
  border: 1px solid lightgrey;
}
.delete-user-icon img {
  width: 100%;
}
.image-root p {
  margin: 0;
}
.user-name {
  font-weight: 300;
  font-size: 15px;
  margin-top: 5px;
  margin-bottom: 0;
}
.user-avatar-root.active .user-name {
  font-weight: 500;
}
@media(max-width: 1500px) {
  .user-avatar-root {
    width: calc(50% - 20px)
  }
}
</style>
